export default __webpack_public_path__ + "static/media/language.29e50276.svg";